import { render, staticRenderFns } from "./MoveLeadToOpportunity.vue?vue&type=template&id=5569c0ba&scoped=true"
import script from "./MoveLeadToOpportunity.vue?vue&type=script&lang=js"
export * from "./MoveLeadToOpportunity.vue?vue&type=script&lang=js"
import style0 from "./MoveLeadToOpportunity.vue?vue&type=style&index=0&id=5569c0ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5569c0ba",
  null
  
)

export default component.exports